import { graphql } from '@eluve/graphql.tada';

export const updateUserDefaultBundleMutation = graphql(`
  mutation updateUserDefaultBundle(
    $tenantId: uuid!
    $userId: uuid!
    $defaultTemplateBundleId: uuid
  ) {
    updateTenantUserSettingsByPk(
      pkColumns: { tenantId: $tenantId, userId: $userId }
      _set: { defaultTemplateBundleId: $defaultTemplateBundleId }
    ) {
      __typename
      tenantId
      userId
      defaultTemplateBundleId
    }
  }
`);
